import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  AWAITING_PAYMENT,
  AWAITING_SHIPMENT,
  CANCELLED,
  ON_HOLD,
  PENDING_FULFILLMENT,
  REJECTED_FULFILLMENT,
  SHIPPED,
  PENDING_PICKUP,
} from '../../../services/api/order-status-from-view-service';
import { messages } from './messages';

export const awaitingPayment = {
  id: 'AWAITING_PAYMENT',
  apiKey: AWAITING_PAYMENT,
  component: <FormattedMessage {...messages.awaitingPayment} />,
};

export const onHold = {
  id: 'ONHOLD',
  apiKey: ON_HOLD,
  component: <FormattedMessage {...messages.onHold} />,
};

export const awaitingShipment = {
  id: 'AWAITING_SHIPMENT',
  apiKey: AWAITING_SHIPMENT,
  component: <FormattedMessage {...messages.awaitingShipment} />,
};

export const pendingfulfillment = {
  id: 'PENDING_FULFILLMENT',
  apiKey: PENDING_FULFILLMENT,
  component: <FormattedMessage {...messages.pendingFulfillment} />,
};

export const rejectedfulfillment = {
  id: 'REJECTED_FULFILLMENT',
  apiKey: REJECTED_FULFILLMENT,
  component: <FormattedMessage {...messages.rejectedFulfillment} />,
};

export const pendingpickup = {
  id: 'PENDING_PICKUP',
  apiKey: PENDING_PICKUP,
  component: <FormattedMessage {...messages.pendingPickup} />,
};

export const shipped = {
  id: 'SHIPPED',
  apiKey: SHIPPED,
  component: <FormattedMessage {...messages.shipped} />,
};

export const cancelled = {
  id: 'CANCELLED',
  apiKey: CANCELLED,
  component: <FormattedMessage {...messages.cancelled} />,
};

export const orderStatusOptions = [awaitingPayment, onHold, awaitingShipment, pendingfulfillment, rejectedfulfillment, shipped, cancelled];
